import { getAccessToken, renewAccessToken } from '@/lib/auth/tokenStore';
import { env } from '@/lib/env';

/**
 * Saves one of the console's CSV exports (spec 191, service spec 157 FR-005,
 * FR-006).
 *
 * A raw `fetch` for the reason `useDownloadWorkspaceFile` gives: the body is a
 * file, not JSON, and a plain link cannot carry the bearer token. Renews once
 * on a 401 and replays, as `client.ts` does, then hands the bytes to the
 * browser's own download.
 */
function send(url: string): Promise<Response> {
  const token = getAccessToken();
  return fetch(url, {
    headers: token
      ? { Accept: 'text/csv', Authorization: `Bearer ${token}` }
      : { Accept: 'text/csv' },
  });
}

export async function downloadCsv(path: string, name: string): Promise<void> {
  const url = `${env.VITE_API_BASE_URL}${path}`;
  let response = await send(url);
  if (response.status === 401 && getAccessToken()) {
    const renewed = await renewAccessToken();
    if (renewed) response = await send(url);
  }
  if (!response.ok) throw new Error('The file could not be downloaded.');

  const objectUrl = URL.createObjectURL(await response.blob());
  try {
    const anchor = document.createElement('a');
    anchor.href = objectUrl;
    anchor.download = name;
    anchor.click();
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
